export const translations = {
  zh: {
    titleTarot: "写下问题，抽一张牌",
    titleSixYao: '写下疑惑，起卦一问',

    tabTarot: '塔罗牌',
    tabSixYao: '六爻起卦',
    buttonTextSixYao: '诚心起卦',
    yaoPositions: ['初爻', '二爻', '三爻', '四爻', '五爻', '上爻'],

    questionLabel: "你心里想问什么？",
    placeholder: "我该接受那个 offer 吗？",
    buttonTextTarot: "深呼吸，开始抽牌",
    resetText: "重新提问",
    readingLoading: "正在观象，稍候…",
    readingEmpty: "揭开所有牌后，解读将在此处呈现",

    noQuestion: "请先写下你心里的问题",
    noResult: "暂无解读结果",
    failed: "解读遇到了阻碍，可以稍后重试",
    retryText: "重新解读",
    
    positions: ["过去", "现在", "未来"],
    positionsCeltic: [
        "现状", "阻碍", "过去", 
        "未来", "意识", "潜意识", 
        "建议", "外在", "愿景", "结果"
      ],
    
    upright: "正位",
    reversed: "逆位",

    birthYear: "出生年",
    birthMonth: "出生月",
    birthDay: "出生日",
    country: "出生国",
    city: "出生城市",
    countryPlaceholder: "中国",
    cityPlaceholder: "北京",
    gender: "性别",
    select: "请选择",
    male: "男",
    female: "女",
    others: "其他",

    aries: "白羊座",
    taurus: "金牛座",
    gemini: "双子座",
    cancer: "巨蟹座",
    leo: "狮子座",
    virgo: "处女座",
    libra: "天秤座",
    scorpio: "天蝎座",
    sagittarius: "射手座",
    capricorn: "摩羯座",
    aquarius: "水瓶座",
    pisces: "双鱼座",
    
    newMoon: "新月",
    waxingCrescent: "蛾眉月",
    firstQuarter: "上弦月",
    waxingGibbous: "盈凸月",
    fullMoon: "满月",
    waningGibbous: "亏凸月",
    lastQuarter: "下弦月",
    waningCrescent: "残月",

    expandInfo: '加入更多背景，让解读更贴近你的处境',
    collapseInfo: '收起',

    processing: '处理中…',
    unlockStripe: '解锁完整解读',

    lockedLines: "... 还有 {count} 行内容需解锁",
    exportScreenshot: "保存解读",

    // ── 六爻组件 ──────────────────────────────────────
    waitingForYao: "等待摇卦结果…",
    divinationTime: "起卦时间",
    outerTrigram: "外卦",
    innerTrigram: "内卦",
    mainHexagramLabel: "本卦",
    changeHexagramLabel: "变卦",
    hexagramDrawing: "正在起卦",
    hexagramComplete: "起卦完成",
    calculating: "计算中…",
    noMovingYao: "无动爻（情况稳定，短期内难以改变）",
    yaoTypeNames: { 6: '老阴', 7: '少阳', 8: '少阴', 9: '老阳' },

    // ── 防止重复提问 ──────────────────────────────────
    castingHintTarot: "💡 诚心所愿，一次一问。频繁抽牌同一问题可能会影响牌意的准确性。",
    castingHintSixYao: "💡 诚心起卦，一事一占。频繁提问同一问题可能会导致卦象不准。",
    disclaimerTitle: "关于后续",
    disclaimerText: "本次预测有效期约为 3–6 个月。建议给现实生活留出改变的空间。若近期心境无重大变化，重复提问将难以获得更深层的启示。"
  },
  
  en: {
    titleTarot: "Say what's on your mind. Draw a card.",
    titleSixYao: 'Say what\'s on your mind. Cast a hexagram.',

    tabTarot: 'Tarot',
    tabSixYao: 'I Ching',
    buttonTextSixYao: 'Cast the Hexagram',

    // 六爻位置
    yaoPositions: ['First Line', 'Second Line', 'Third Line', 'Fourth Line', 'Fifth Line', 'Top Line'],

    questionLabel: "What's the question?",
    placeholder: "Should I take that job offer?",
    buttonTextTarot: "Breathe, and draw your cards",
    resetText: "Ask again",
    readingLoading: "Reading the signs…",
    readingEmpty: "Your reading will appear once all cards are revealed.",

    noQuestion: "Write down your question first",
    noResult: "No reading yet",
    failed: "Something interrupted the reading — try again",
    retryText: "Try again",
    
    positions: ["Past", "Present", "Future"],  
    positionsCeltic: [
        "The Present",
        "The Challenge",
        "The Past",
        "The Future",
        "Conscious",
        "Subconscious",
        "Advice",
        "External Influences",
        "Hopes & Fears",
        "Outcome"
      ],
    upright: "Upright",  
    reversed: "Reversed",

    birthYear: "Birth Year",
    birthMonth: "Birth Month", 
    birthDay: "Birth Day",
    country: "Country",
    city: "City",
    countryPlaceholder: "USA",
    cityPlaceholder: "New York",
    gender: "Gender",
    select: "Please select",
    male: "Male",
    female: "Female",
    others: "Other",

    aries: "Aries",
    taurus: "Taurus",
    gemini: "Gemini",
    cancer: "Cancer",
    leo: "Leo",
    virgo: "Virgo",
    libra: "Libra",
    scorpio: "Scorpio",
    sagittarius: "Sagittarius",
    capricorn: "Capricorn",
    aquarius: "Aquarius",
    pisces: "Pisces",
    
    newMoon: "New Moon",
    waxingCrescent: "Waxing Crescent",
    firstQuarter: "First Quarter",
    waxingGibbous: "Waxing Gibbous",
    fullMoon: "Full Moon",
    waningGibbous: "Waning Gibbous",
    lastQuarter: "Last Quarter",
    waningCrescent: "Waning Crescent",

    expandInfo: 'Add context for a more personal reading',
    collapseInfo: 'Collapse',

    processing: 'Processing…',
    unlockStripe: 'Unlock Full Reading',

    lockedLines: "... {count} lines to be unlocked",
    exportScreenshot: "Save Reading",

    // ── Six Yao components ────────────────────────────
    waitingForYao: "Awaiting hexagram result…",
    divinationTime: "Time of Divination",
    outerTrigram: "Upper Trigram",
    innerTrigram: "Lower Trigram",
    mainHexagramLabel: "Primary",
    changeHexagramLabel: "Changing",
    hexagramDrawing: "Casting Hexagram",
    hexagramComplete: "Hexagram Cast",
    calculating: "Calculating…",
    noMovingYao: "No moving lines — the situation is stable and unlikely to shift in the short term.",
    yaoTypeNames: { 6: 'Old Yin', 7: 'Young Yang', 8: 'Young Yin', 9: 'Old Yang' },

    // ── Repeat-question deterrent ─────────────────────
    castingHintTarot: "💡 One question, one reading. Repeatedly drawing for the same question may weaken the clarity of the cards.",
    castingHintSixYao: "💡 One matter, one casting. Asking the same question repeatedly may cloud the hexagram's guidance.",
    disclaimerTitle: "A Note on What Comes Next",
    disclaimerText: "This reading is valid for approximately 3–6 months. Allow space for life to unfold. If your situation or mindset hasn't changed significantly, repeating the question is unlikely to yield deeper insight."
  },
  
  ar: {
    titleTarot: "تشعر بالحيرة؟ اسحب بطاقة",  
    titleSixYao: 'في حيرة من أمرك؟ اطلب الحكمة من اليي جينغ',
    tabTarot: 'قراءة التاروت',
    tabSixYao: 'استشارة اليي جينغ',
    buttonTextSixYao: 'ألقي الهكساغرام بصدق',
    
    // 六爻位置
    yaoPositions: ['الخط الأول', 'الخط الثاني', 'الخط الثالث', 'الخط الرابع', 'الخط الخامس', 'الخط الأعلى'],
    questionLabel: "ما الذي يشغل بالك؟",  
    placeholder: "هل يجب أن أقبل هذا العرض؟",  
    buttonTextTarot: "تنفّس بعمق وابدأ بالسحب",  
    resetText: "سؤال جديد",  
    readingLoading: "جاري التفسير، يرجى الانتظار…",  
    readingEmpty: "سيظهر التفسير بعد الكشف عن جميع البطاقات.",  
    
    noQuestion: "لم تكتب سؤالك بعد 😅",  
    noResult: "لم يتم الحصول على نتيجة 😅",  
    failed: "فشل التفسير، يرجى المحاولة لاحقاً 😅",
    
    positions: ["الماضي", "الحاضر", "المستقبل"],
    positionsCeltic: [
        "الحاضر",
        "التحدي",
        "الماضي",
        "المستقبل",
        "الوعي",
        "العقل الباطن",
        "النصيحة",
        "المؤثرات الخارجية",
        "الآمال والمخاوف",
        "النتيجة"
      ],
    upright: "في الوضع الصحيح",  
    reversed: "معكوس",

    birthYear: "سنة الميلاد",
    birthMonth: "شهر الميلاد",
    birthDay: "يوم الميلاد", 
    country: "الدولة",
    city: "المدينة",
    countryPlaceholder: "مصر",
    cityPlaceholder: "القاهرة",
    gender: "الجنس",
    select: "الرجاء الاختيار",
    male: "ذكر",
    female: "أنثى",
    others: "أخرى",

    aries: "الحمل",
    taurus: "الثور",
    gemini: "الجوزاء",
    cancer: "السرطان",
    leo: "الأسد",
    virgo: "العذراء",
    libra: "الميزان",
    scorpio: "العقرب",
    sagittarius: "القوس",
    capricorn: "الجدي",
    aquarius: "الدلو",
    pisces: "الحوت",
    
    newMoon: "محاق",
    waxingCrescent: "هلال متزايد",
    firstQuarter: "التربيع الأول",
    waxingGibbous: "أحدب متزايد",
    fullMoon: "بدر",
    waningGibbous: "أحدب متناقص",
    lastQuarter: "التربيع الأخير",
    waningCrescent: "هلال متناقص",

    expandInfo: 'أضف تفاصيل للحصول على رؤى أعمق',
    collapseInfo: 'تقليل المعلومات',

    processing: 'جارٍ المعالجة...',
    unlockStripe: 'فتح القراءة الكاملة',

    lockedLines: "... {count} سطر لإلغاء القفل",
    exportScreenshot: "حفظ القراءة",

    // ── مكوّنات السداسي ───────────────────────────────
    waitingForYao: "في انتظار نتيجة الهكساغرام…",
    divinationTime: "وقت الاستشارة",
    outerTrigram: "المثلث العلوي",
    innerTrigram: "المثلث السفلي",
    mainHexagramLabel: "الرئيسي",
    changeHexagramLabel: "المتحوّل",
    hexagramDrawing: "جارٍ رمي الهكساغرام",
    hexagramComplete: "اكتمل الرمي",
    calculating: "جارٍ الحساب…",
    noMovingYao: "لا خطوط متحركة — الوضع مستقر ولن يتغير في المدى القريب.",
    yaoTypeNames: { 6: 'الين القديم', 7: 'اليانغ الشاب', 8: 'الين الشاب', 9: 'اليانغ القديم' },

    // ── منع تكرار الأسئلة ─────────────────────────────
    castingHintTarot: "💡 سؤال واحد، قراءة واحدة. تكرار نفس السؤال قد يُشوّش معنى البطاقات.",
    castingHintSixYao: "💡 مسألة واحدة، استشارة واحدة. تكرار السؤال ذاته قد يُضعف دقة الهكساغرام.",
    disclaimerTitle: "ملاحظة حول ما يلي",
    disclaimerText: "هذه القراءة صالحة لمدة 3 إلى 6 أشهر تقريباً. امنح الوقت للأمور لكي تتطور. إذا لم تتغير ظروفك أو مشاعرك، فإن تكرار السؤال نفسه لن يمنحك رؤى أعمق."
  },

  ja: {
    titleTarot: "迷ったときは、カードに聞いてみよう",
    titleSixYao: '迷った時、易占いで質問',
    // 导航/按钮
    tabTarot: 'タロット占い',
    tabSixYao: '易占い',
    buttonTextSixYao: '誠心誠意、卦を立てる',
    
    // 六爻位置
    yaoPositions: ['初爻', '二爻', '三爻', '四爻', '五爻', '上爻'],
    
    questionLabel: "心の中で何を聞きたいですか？",
    placeholder: "このオファーを受けるべき？",
    buttonTextTarot: "深呼吸して、カードを引く",
    resetText: "別の質問にする",
    readingLoading: "リーディング中…少々お待ちください",
    readingEmpty: "すべてのカードがめくられると、結果が表示されます。",
  
    noQuestion: "まだ質問を書いていません～",
    noResult: "リーディング結果がありません～",
    failed: "占いに失敗しました。しばらくしてから再試行してください～",
  
    positions: ["過去", "現在", "未来"],
    positionsCeltic: [
        "現状",
        "障害",
        "過去",
        "未来",
        "顕在意識",
        "潜在意識",
        "助言",
        "周囲の状況",
        "願望",
        "最終結果"
      ],
    upright: "正位置",
    reversed: "逆位置",
  
    birthYear: "生年",
    birthMonth: "誕生月",
    birthDay: "誕生日",
    country: "国",
    city: "都市",
    countryPlaceholder: "日本",
    cityPlaceholder: "東京",
    gender: "性別",
    select: "選択してください",
    male: "男性",
    female: "女性",
    others: "その他",
  
    aries: "おひつじ座",
    taurus: "おうし座",
    gemini: "ふたご座",
    cancer: "かに座",
    leo: "しし座",
    virgo: "おとめ座",
    libra: "てんびん座",
    scorpio: "さそり座",
    sagittarius: "いて座",
    capricorn: "やぎ座",
    aquarius: "みずがめ座",
    pisces: "うお座",
  
    newMoon: "新月",
    waxingCrescent: "三日月",
    firstQuarter: "上弦の月",
    waxingGibbous: "十三夜",
    fullMoon: "満月",
    waningGibbous: "十六夜",
    lastQuarter: "下弦の月",
    waningCrescent: "三十日月",
  
    expandInfo: '詳しい情報を入力して、より深いリーディングを',
    collapseInfo: '情報を閉じる',
  
    processing: '処理中...',
    unlockStripe: '完全なリーディングを解放する',
  
    lockedLines: "... 残り {count} 行の内容を解放",
    exportScreenshot: "リーディングを保存",

    // ── 六爻コンポーネント ─────────────────────────────
    waitingForYao: "卦の結果を待っています…",
    divinationTime: "起卦時刻",
    outerTrigram: "外卦",
    innerTrigram: "内卦",
    mainHexagramLabel: "本卦",
    changeHexagramLabel: "変卦",
    hexagramDrawing: "起卦中",
    hexagramComplete: "起卦完了",
    calculating: "計算中…",
    noMovingYao: "動爻なし — 状況は安定しており、短期間では変化しにくいです。",
    yaoTypeNames: { 6: '老陰', 7: '少陽', 8: '少陰', 9: '老陽' },

    // ── 重複質問の抑止 ────────────────────────────────
    castingHintTarot: "💡 一問一読み。同じ質問を繰り返すと、カードの意味が薄れることがあります。",
    castingHintSixYao: "💡 誠心誠意を持って卦を立ててください。同じ質問を繰り返すと、卦の精度が下がる可能性があります。",
    disclaimerTitle: "今後について",
    disclaimerText: "このリーディングの有効期間は約3〜6ヶ月です。現実が変化するための時間を与えてください。最近、心境や状況に大きな変化がない場合、同じ質問を繰り返しても、より深い洞察を得るのは難しいかもしれません。"
  },
  ko: {
    titleTarot: "갈 길을 몰라? 카드를 뽑아봐요",
    titleSixYao: '결정이 어렵다면? 주역 괘를 뽑아보세요',
    // 导航/按钮
    tabTarot: '타로 카드 점',
    tabSixYao: '주역 괘 묻기',
    buttonTextSixYao: '정성껏 괘를 뽑습니다',
    
    // 六爻位置
    yaoPositions: ['초효', '이효', '삼효', '사효', '오효', '상효'],
    
    questionLabel: "마음속으로 어떤 질문을 하고 싶나요?",
    placeholder: "그 제안을 받아들여야 할까?",
    buttonTextTarot: "심호흡하고 카드 뽑기",
    resetText: "다른 질문으로",
    readingLoading: "리딩 중이에요... 잠시만 기다려 주세요",
    readingEmpty: "모든 카드가 공개되면 결과가 나타납니다.",
  
    noQuestion: "아직 질문을 입력하지 않았어요～",
    noResult: "리딩 결과가 없어요～",
    failed: "점이 실패했어요. 잠시 후 다시 시도해 주세요～",
  
    positions: ["과거", "현재", "미래"],
    positionsCeltic: [
        "현재",
        "장애물",
        "과거",
        "미래",
        "의식",
        "잠재의식",
        "조언",
        "외부 영향",
        "희망과 두려움",
        "결과"
      ],
    upright: "정위",
    reversed: "역위",
  
    birthYear: "출생 연도",
    birthMonth: "출생 월",
    birthDay: "출생 일",
    country: "국가",
    city: "도시",
    countryPlaceholder: "대한민국",
    cityPlaceholder: "서울",
    gender: "성별",
    select: "선택하세요",
    male: "남성",
    female: "여성",
    others: "기타",
  
    aries: "양자리",
    taurus: "황소자리",
    gemini: "쌍둥이자리",
    cancer: "게자리",
    leo: "사자자리",
    virgo: "처녀자리",
    libra: "천칭자리",
    scorpio: "전갈자리",
    sagittarius: "사수자리",
    capricorn: "염소자리",
    aquarius: "물병자리",
    pisces: "물고기자리",
  
    newMoon: "신월",
    waxingCrescent: "초승달",
    firstQuarter: "상현달",
    waxingGibbous: "보름달 직전",
    fullMoon: "보름달",
    waningGibbous: "보름달 이후",
    lastQuarter: "하현달",
    waningCrescent: "그믐달",
  
    expandInfo: "더 깊은 리딩을 위해 정보를 입력하세요",
    collapseInfo: "정보 접기",
  
    processing: "처리 중...",
    unlockStripe: "전체 리딩 해제",
  
    lockedLines: "... {count}줄의 내용을 해제해야 합니다",
    exportScreenshot: "리딩 저장",

    // ── 육효 컴포넌트 ──────────────────────────────────
    waitingForYao: "괘 결과를 기다리는 중…",
    divinationTime: "기점 시간",
    outerTrigram: "상괘",
    innerTrigram: "하괘",
    mainHexagramLabel: "본괘",
    changeHexagramLabel: "변괘",
    hexagramDrawing: "괘를 뽑는 중",
    hexagramComplete: "기점 완료",
    calculating: "계산 중…",
    noMovingYao: "동효 없음 — 상황이 안정적이며 단기간 내 변화하기 어렵습니다.",
    yaoTypeNames: { 6: '노음', 7: '소양', 8: '소음', 9: '노양' },

    // ── 반복 질문 방지 ─────────────────────────────────
    castingHintTarot: "💡 하나의 질문, 하나의 카드. 같은 질문을 반복하면 카드의 정확성이 떨어질 수 있습니다.",
    castingHintSixYao: "💡 정성을 담아 괘를 뽑으세요. 같은 질문을 반복하면 괘가 부정확할 수 있습니다.",
    disclaimerTitle: "앞으로에 대하여",
    disclaimerText: "이번 리딩은 약 3–6개월 동안 유효합니다. 현실이 변화할 시간을 주세요. 최근에 마음이나 상황에 큰 변화가 없다면, 같은 질문을 반복해도 더 깊은 통찰을 얻기 어렵습니다."
  },
  zhHant: {
    titleTarot: "遇事不決？抽張牌看看吧",
    titleSixYao: '遇事不決？起卦問事',
    // 导航/按钮
    tabTarot: '塔羅牌占卜',
    tabSixYao: '起卦問事',
    buttonTextSixYao: '誠心起卦',
    
    // 六爻位置
    yaoPositions: ['初爻', '二爻', '三爻', '四爻', '五爻', '上爻'],
    questionLabel: "你心裡想問什麼？",
    placeholder: "我該接受那個 offer 嗎？",
    buttonTextTarot: "深呼吸，開始抽牌",
    resetText: "換個問題",
    readingLoading: "正在解讀，請稍候…",
    readingEmpty: "所有牌揭示後，解讀結果將出現。",
  
    noQuestion: "請先寫下你心裡的問題",
    noResult: "暫無解讀結果",
    failed: "解讀遇到了阻礙，可以稍後重試",
  
    positions: ["過去", "現在", "未來"],
    positionsCeltic: [
        "現狀",
        "阻礙",
        "過去",
        "未來",
        "意識",
        "潛意識",
        "建議",
        "外在",
        "願景",
        "結果"
      ],
    upright: "正位",
    reversed: "逆位",
  
    birthYear: "出生年",
    birthMonth: "出生月",
    birthDay: "出生日",
    country: "國家",
    city: "城市",
    countryPlaceholder: "台灣",
    cityPlaceholder: "台北",
    gender: "性別",
    select: "請選擇",
    male: "男",
    female: "女",
    others: "其他",
  
    aries: "牡羊座",
    taurus: "金牛座",
    gemini: "雙子座",
    cancer: "巨蟹座",
    leo: "獅子座",
    virgo: "處女座",
    libra: "天秤座",
    scorpio: "天蠍座",
    sagittarius: "射手座",
    capricorn: "魔羯座",
    aquarius: "水瓶座",
    pisces: "雙魚座",
  
    newMoon: "新月",
    waxingCrescent: "眉月",
    firstQuarter: "上弦月",
    waxingGibbous: "盈凸月",
    fullMoon: "滿月",
    waningGibbous: "虧凸月",
    lastQuarter: "下弦月",
    waningCrescent: "殘月",
  
    expandInfo: "輸入更多資訊，獲得更深入的解讀",
    collapseInfo: "收起資訊",
  
    processing: "處理中...",
    unlockStripe: "解鎖完整解讀",
  
    lockedLines: "... 還有 {count} 行內容需解鎖",
    exportScreenshot: "保存解讀",

    // ── 六爻組件 ──────────────────────────────────────
    waitingForYao: "等待搖卦結果…",
    divinationTime: "起卦時間",
    outerTrigram: "外卦",
    innerTrigram: "內卦",
    mainHexagramLabel: "本卦",
    changeHexagramLabel: "變卦",
    hexagramDrawing: "正在起卦",
    hexagramComplete: "起卦完成",
    calculating: "計算中…",
    noMovingYao: "無動爻（情況穩定，短期內難以改變）",
    yaoTypeNames: { 6: '老陰', 7: '少陽', 8: '少陰', 9: '老陽' },

    // ── 防止重複提問 ──────────────────────────────────
    castingHintTarot: "💡 誠心所願，一次一問。頻繁抽牌同一問題可能會影響牌意的準確性。",
    castingHintSixYao: "💡 誠心起卦，一事一占。頻繁提問同一問題可能會導致卦象不準。",
    disclaimerTitle: "關於後續",
    disclaimerText: "本次預測有效期約為 3–6 個月。建議給現實生活留出改變的空間。若近期心境無重大變化，重複提問將難以獲得更深層的啟示。"
  }

};  
